// What the agents asked to do in the books: the shared inbox of agent requests, narrowed to the
// books' own (money, the ledger, bank, tax, collections).

import { ApprovalsInbox } from '../shared/ApprovalsInbox.tsx';
import type { BooksProps } from './props.ts';
import { isBooksRequest } from './model.ts';

export function Approvals({ toast }: BooksProps) {
  return (
    <ApprovalsInbox
      toast={toast}
      filter={isBooksRequest}
      title="Agent requests"
      intro="What the agents asked to do in the books. Nothing runs until a person decides; the input cannot be edited."
    />
  );
}
